var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDevelopBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#121516"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1221 85.5387L50.9451 77.0619L59.1221 68.5851L61.7958 71.167L56.0966 77.0619L61.7958 82.9568L59.1221 85.5387ZM80.8531 85.5611L78.2241 82.932L84.0966 77.0594L78.2241 71.1869L80.8531 68.5578L89.3523 77.0569L80.8531 85.5611ZM66.9696 85.2662L63.8623 83.2293L73.2782 68.8577L76.3855 70.8946L66.9696 85.2662ZM42 42H98V98H42V42ZM94.2832 45.7168H45.7168V94.2832H94.2832V45.7168ZM98 60.0885H42V42H98V60.0885ZM45.7168 56.3717H94.2832V45.7167H45.7169L45.7168 56.3717ZM55.7522 52.9027H51.0442V49.1858H55.7522V52.9027ZM65.4159 52.9027H60.4601V49.1858H65.4159V52.9027ZM74.8318 52.9027H70.1239V49.1858H74.8318V52.9027Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopBlack);
export default __webpack_public_path__ + "static/media/web-develop-black.d8a4df4d85cdde1ba2efb85bbdb66867.svg";
export { ForwardRef as ReactComponent };